import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './RewardsLoader.module.scss';

const RewardsLoader = ({ count, baseColor, highlightColor }) => (
  <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
    {Array.from({ length: count }).map(() => (
      <div key={uuidv4()} className={styles.rewardsSubContainer}>
        <Skeleton circle width={40} height={40} />
        <div className={styles.contentWidth}>
          <Skeleton width="50%" height={16} />
          <Skeleton width="100%" height={8} />
        </div>
      </div>
    ))}
  </SkeletonTheme>
);

export default RewardsLoader;
